<div [formGroup]="form">
    @if(isFabricado){
    <div class="section-container" id="producao">
        <div class="section-title">
            <mat-icon>factory</mat-icon>
            <span>Produção</span>
        </div>
        <div class="row">
            <div class="col-12 col-md-3">
                <p>
                    <mat-slide-toggle class="app-toggle-compact" formControlName="isGerarOrdemProducao">Gerar ordem de
                        produção</mat-slide-toggle>
                </p>
            </div>
        </div>

        <!-- Grid Estrutura -->
        <div formArrayName="producao">
            <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
                <p class="mb-0">Estrutura</p>
                <div class="d-flex gap-2">
                    <button mat-button type="button" (click)="atualizarCustoProduto()">
                        <mat-icon class="me-1">refresh</mat-icon> Atualizar custo
                    </button>
                    <button mat-button type="button" (click)="addProducaoRow()">
                        <mat-icon>add</mat-icon> Adicionar item
                    </button>
                </div>
            </div>

            @for (item of producao.controls; track item; let i = $index) {
            <div [formGroupName]="i">
                <div class="row margin-bottom-50">
                    <div class="col-10 col-md-11">
                        <div class="row">
                            <!-- Produto -->
                            <div class="col-8 col-lg-3">
                                <app-select-pesquisavel [apiUrl]="urlProduto"
                                    [control]="getControl(item, 'idProdutoInsumo')" idField='idProduto'
                                    nameField='descricao' label="Produto" placeholder="Pesquise o produto..."
                                    [preloadedOptions]="item.get('preloadedList')?.value"
                                    [hint]="item.get('skuProdutoInsumo')?.value ? 'SKU: ' + item.get('skuProdutoInsumo')?.value : ''"
                                    (selectionChange)="onProdutoProducaoSelected($event, i)">
                                </app-select-pesquisavel>
                            </div>

                            <!-- Quantidade -->
                            <div class="col-4 col-lg-2">
                                <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                    class="w-100 no-bottom-space compact-input">
                                    <mat-label>Quantidade</mat-label>
                                    <input matInput formControlName="quantidade" [currencyMask]="quantidadeMask">
                                </mat-form-field>
                            </div>

                            <!-- Unidade -->
                            <div class="col-4 col-lg-1">
                                <span class="mobile-label">Unidade</span>
                                <div>{{ item.get('unidade')?.value ? item.get('unidade')?.value : '-'}}</div>
                            </div>

                            <!-- Custo -->
                            <div class="col-4 col-lg-3">
                                <span class="mobile-label">Custo</span>
                                <div class="fw-bold valor-monetario">{{ item.get('custoExibido')?.value | abnt:'preco'}}
                                </div>
                            </div>

                            <!-- Total -->
                            <div class="col-4 col-lg-3">
                                <span class="mobile-label">Total</span>
                                <div class="fw-bold valor-monetario">{{ item.get('total')?.value | abnt:'preco' }}</div>
                            </div>

                        </div>
                    </div>

                    <!-- Delete -->
                    <div class="col-2 col-md-1 produto-grid-delete-col">
                        <button mat-icon-button class="produto-grid-delete-button" type="button"
                            (click)="removeProducaoRow(i)" matTooltip="Remover">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            }

            @if (producao.length === 0) {
            <app-empty-state icon="factory" title="Nenhum item adicionado à estrutura."
              subtitle="A estrutura define os insumos consumidos para fabricar este produto.">
            </app-empty-state>
            }
        </div>
    </div>

    <!-- Grid Etapas de Produção -->
    <div class="section-container" id="etapasProducao">
        <div class="section-title">
            <mat-icon>format_list_numbered</mat-icon>
            <span>Etapas de Produção</span>
        </div>

        <div formArrayName="etapasProducao">
            <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
                <p class="mb-0">Etapas</p>
                <button mat-button type="button" (click)="addEtapaProducaoRow()">
                    <mat-icon>add</mat-icon> Adicionar etapa
                </button>
            </div>

            <div cdkDropList (cdkDropListDropped)="dropEtapa($event)">
                @for (item of etapasProducao.controls; track item; let i = $index) {
                <div [formGroupName]="i" class="row-wrapper" cdkDrag>
                    <div class="row w-100 g-2 align-items-center m-0">
                        <div class="col-auto posicao-col">{{ i + 1 }}</div>
                        <div class="col-auto drag-handle" cdkDragHandle matTooltip="Arraste para reordenar">
                            <mat-icon>drag_indicator</mat-icon>
                        </div>
                        <div class="col-7 col-lg-9">
                            <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                class="w-100 no-bottom-space compact-input">
                                <mat-label>Descrição</mat-label>
                                <input matInput formControlName="descricao">
                            </mat-form-field>
                        </div>
                        <div class="col-2 col-lg-1 delete-col produto-grid-delete-col">
                            <button mat-icon-button class="produto-grid-delete-button" type="button"
                                (click)="removeEtapaProducaoRow(i)" matTooltip="Remover">
                                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="etapa-preview" *cdkDragPreview>
                        {{ i + 1 }}. {{ getControl(item, 'descricao').value }}
                    </div>
                </div>
                }
            </div>

            @if (etapasProducao.length === 0) {
            <app-empty-state icon="format_list_numbered" title="Nenhuma etapa cadastrada."
              subtitle="As etapas descrevem o processo de fabricação deste produto.">
            </app-empty-state>
            }
        </div>
    </div>
    }
</div>